/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
/* eslint-disable max-len */

import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import Layout from '../../layout';
import PageCard from '../../page-card';
import { Namespaces } from '../../../utils/i18n';

const { PUBLIC_URL } = process.env;

type Props = {
	className?: string;
};

const defaultProps = {
	className: '',
};

const Forbidden = ({ className }: Props): ReactElement => {
	const { t } = useTranslation(Namespaces.Common);
	return (
		<div className={className}>
			<Layout>
				<PageCard>
					<img src={`${PUBLIC_URL}/images/forbidden.svg`} alt={t('forbidden.imageAlt')} className="top-image" />
					<h1>{t('forbidden.title')}</h1>
					<p>{t('forbidden.message')}</p>
				</PageCard>
			</Layout>
		</div>
	);
};

Forbidden.defaultProps = defaultProps;

export default Forbidden;
